export const RECEIVE_RESOLUTION_TYPE = 'RECEIVE_RESOLUTION_TYPE';

export const RESOLUTION_FORM_COMPLETED = 'RESOLUTION_FORM_COMPLETED';

export const receiveResolutionType = (resolutionType) => ({
  type: RECEIVE_RESOLUTION_TYPE,
  data: { resolutionType },
});

export const resolutionFormCompleted = (formCompleted) => ({
  type: RESOLUTION_FORM_COMPLETED,
  data: { formCompleted },
});
